const $inject = [];

const creditCardNumberFilter = () => {
  return (cardNumber) => {
    cardNumber = cardNumber.toString();
    const cardNumbers = cardNumber.split('');
    let formattedNumber = '';

    cardNumbers.forEach((number, numberIndex) => {
      if(numberIndex !== 0 && numberIndex % 4 === 0) {
        formattedNumber += '  ';
      }

      formattedNumber += number;
    });

    return formattedNumber;
  }
};

creditCardNumberFilter.$inject = $inject;

export default creditCardNumberFilter;



// WEBPACK FOOTER //
// ./src/filters/creditCardNumberFilter.js